/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

/** 
  All of the routes for the Vision UI Dashboard PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Vision UI Dashboard PRO React layouts
import Default from 'layouts/dashboards/default';
import CRM from 'layouts/dashboards/crm';
import Overview from 'layouts/dashboards/overview';
import Takedowns from 'layouts/dashboards/takedowns';
import Platforms from 'layouts/dashboards/platforms';
import Threats from 'layouts/dashboards/threats';
import SubmitContent from 'layouts/applications/submit';
import ReviewContent from 'layouts/applications/reviewcontent';
import WeeklyReports from 'layouts/dashboards/reports';
import TakedownDetails from 'layouts/applications/takedowns/details';
import PlatformDetails from 'layouts/applications/platforms/details';
import ThreatActorDetails from 'layouts/applications/threats/details';
import ProfileOverview from 'layouts/pages/profile/profile-overview';
import Teams from 'layouts/pages/profile/teams';
import AllProjects from 'layouts/pages/profile/all-projects';
import Reports from 'layouts/pages/users/reports';
import NewUser from 'layouts/pages/users/new-user';
import Settings from 'layouts/pages/account/settings';
import Billing from 'layouts/pages/account/billing';
import Invoice from 'layouts/pages/account/invoice';
import General from 'layouts/pages/projects/general';
import Timeline from 'layouts/pages/projects/timeline';
import Widgets from 'layouts/pages/widgets';
import Charts from 'layouts/pages/charts';
import Alerts from 'layouts/pages/alerts';
import PricingPage from 'layouts/pages/pricing-page';
import RTL from 'layouts/pages/rtl';
import Kanban from 'layouts/applications/kanban';
import Wizard from 'layouts/applications/wizard';
import DataTables from 'layouts/applications/data-tables';
import Calendar from 'layouts/applications/calendar';
import NewProduct from 'layouts/ecommerce/products/new-product';
import EditProduct from 'layouts/ecommerce/products/edit-product';
import ProductPage from 'layouts/ecommerce/products/product-page';
import OrderList from 'layouts/ecommerce/orders/order-list';
import OrderDetails from 'layouts/ecommerce/orders/order-details';
import SignInBasic from 'layouts/authentication/sign-in/basic';
import SignInCover from 'layouts/authentication/sign-in/cover';
import SignInIllustration from 'layouts/authentication/sign-in/illustration';
import SignUpBasic from 'layouts/authentication/sign-up/basic';
import SignUpCover from 'layouts/authentication/sign-up/cover';
import SignUpIllustration from 'layouts/authentication/sign-up/illustration';

// React icons
import { IoDocument } from 'react-icons/io5';
import { IoBuild } from 'react-icons/io5';
import { IoDocuments } from 'react-icons/io5';
import { FaShoppingCart } from 'react-icons/fa';
import { IoHome } from 'react-icons/io5';

const routes = [
  {
    type: 'collapse',
    name: 'Dashboards',
    key: 'dashboards',
    icon: <IoHome size="15px" color="inherit" />,
    collapse: [
      {
        name: 'Overview',
        key: 'overview',
        layout: '',
        path: '/dashboards/overview',
        component: <Overview />,
      },
      {
        name: 'Takedowns',
        key: 'takedowns',
        layout: '',
        path: '/dashboards/takedowns',
        component: <Takedowns />,
      },
      {
        name: 'Platform Tracker',
        key: 'platforms',
        layout: '',
        path: '/dashboards/platforms',
        component: <Platforms />,
      },
      {
        name: 'Threat Actor',
        key: 'threats',
        layout: '',
        path: '/dashboards/threats',
        component: <Threats />,
      },
      {
        name: 'Main Dashboard',
        layout: '',
        path: '/dashboards/default',
        component: <Default />,
      },
      {
        name: 'Submit Content',
        key: 'submit',
        layout: '',
        path: '/applications/submit',
        component: <SubmitContent />,
      },
      {
        name: 'Review Content',
        key: 'reviewcontent',
        layout: '',
        path: '/applications/reviewcontent',
        component: <ReviewContent />,
      },
      {
        name: 'Weekly Report',
        key: 'reports',
        layout: '',
        path: '/dashboards/reports',
        component: <WeeklyReports />,
      },
      {
        name: 'Takedown Details',
        key: 'takedown-details',
        layout: '',
        path: '/Dashboards/Takedowns/:takedown_id/Details',
        component: <TakedownDetails />,
      },
      {
        name: 'Platform Details',
        key: 'platform-details',
        layout: '',
        path: '/dashboards/platforms/:platformid/details',
        component: <PlatformDetails />,
      },
      {
        name: 'Threat Actor Details',
        key: 'threat-actor-details',
        layout: '',
        path: '/dashboards/threats/:threatID/details',
        component: <ThreatActorDetails />,
      },
      {
        name: 'CRM',
        key: 'crm',
        layout: '',
        path: '/dashboards/crm',
        component: <CRM />,
      },
    ],
  },
  { type: 'title', title: 'Pages', key: 'title-pages' },
  {
    type: 'collapse',
    name: 'Pages',
    key: 'pages',
    icon: <IoDocument size="15px" color="inherit" />,
    collapse: [
      {
        name: 'Profile',
        key: 'profile',
        collapse: [
          {
            name: 'Profile Overview',
            key: 'profile-overview',

            layout: '',
            path: '/pages/profile/profile-overview',
            component: <ProfileOverview />,
          },
          {
            name: 'Teams',
            key: 'teams',

            layout: '',
            path: '/pages/profile/teams',
            component: <Teams />,
          },
          {
            name: 'All Projects',
            key: 'all-projects',

            layout: '',
            path: '/pages/profile/all-projects',
            component: <AllProjects />,
          },
        ],
      },
      {
        name: 'Users',
        key: 'users',
        collapse: [
          {
            name: 'Reports',
            key: 'reports',

            layout: '',
            path: '/pages/users/reports',
            component: <Reports />,
          },
          {
            name: 'New User',
            key: 'new-user',

            layout: '',
            path: '/pages/users/new-user',
            component: <NewUser />,
          },
        ],
      },
      {
        name: 'Account',
        key: 'account',
        collapse: [
          {
            name: 'Settings',
            key: 'settings',

            layout: '',
            path: '/pages/account/settings',
            component: <Settings />,
          },
          {
            name: 'Billing',
            key: 'billing',

            layout: '',
            path: '/pages/account/billing',
            component: <Billing />,
          },
          {
            name: 'Invoice',
            key: 'invoice',

            layout: '',
            path: '/pages/account/invoice',
            component: <Invoice />,
          },
        ],
      },
      {
        name: 'Projects',
        key: 'projects',
        collapse: [
          {
            name: 'General',
            key: 'general',

            layout: '',
            path: '/pages/projects/general',
            component: <General />,
          },
          {
            name: 'Timeline',
            key: 'timeline',

            layout: '',
            path: '/pages/projects/timeline',
            component: <Timeline />,
          },
        ],
      },
      {
        name: 'Pricing Page',
        key: 'pricing-page',

        layout: '',
        path: '/pages/pricing-page',
        component: <PricingPage />,
      },
      {
        name: 'RTL',
        key: 'rtl',
        layout: '',
        path: '/pages/rtl',
        component: <RTL />,
      },
      {
        name: 'Widgets',
        key: 'widgets',
        layout: '',
        path: '/pages/widgets',
        component: <Widgets />,
      },
      {
        name: 'Charts',
        key: 'charts',
        layout: '',
        path: '/pages/charts',
        component: <Charts />,
      },
      {
        name: 'Alerts',
        key: 'alerts',

        layout: '',
        path: '/pages/alerts',
        component: <Alerts />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'Applications',
    key: 'applications',
    icon: <IoBuild size="15px" color="inherit" />,
    collapse: [
      {
        name: 'Kanban',
        key: 'kanban',

        layout: '',
        path: '/applications/kanban',
        component: <Kanban />,
      },
      {
        name: 'Wizard',
        key: 'wizard',

        layout: '',
        path: '/applications/wizard',
        component: <Wizard />,
      },
      {
        name: 'Data Tables',
        key: 'data-tables',

        layout: '',
        path: '/applications/data-tables',
        component: <DataTables />,
      },
      {
        name: 'Calendar',
        key: 'calendar',

        layout: '',
        path: '/applications/calendar',
        component: <Calendar />,
      },
    ],
  },
  {
    type: 'collapse',
    name: 'Ecommerce',
    key: 'ecommerce',
    icon: <FaShoppingCart size="15px" color="inherit" />,
    collapse: [
      {
        name: 'Products',
        key: 'products',
        collapse: [
          {
            name: 'New Product',
            key: 'new-product',

            layout: '',
            path: '/ecommerce/products/new-product',
            component: <NewProduct />,
          },
          {
            name: 'Edit Product',
            key: 'edit-product',

            layout: '',
            path: '/ecommerce/products/edit-product',
            component: <EditProduct />,
          },
          {
            name: 'Product Page',
            key: 'product-page',

            layout: '',
            path: '/ecommerce/products/product-page',
            component: <ProductPage />,
          },
        ],
      },
      {
        name: 'Orders',
        key: 'orders',
        collapse: [
          {
            name: 'Order List',
            key: 'order-list',

            layout: '',
            path: '/ecommerce/orders/order-list',
            component: <OrderList />,
          },
          {
            name: 'Order Details',
            key: 'order-details',

            layout: '',
            path: '/ecommerce/orders/order-details',
            component: <OrderDetails />,
          },
        ],
      },
    ],
  },
  {
    type: 'collapse',
    name: 'Authentication',
    key: 'authentication',
    icon: <IoDocuments size="15px" color="inherit" />,
    collapse: [
      {
        name: 'Sign In',
        key: 'sign-in',
        collapse: [
          {
            name: 'Basic',
            key: 'basic',
            layout: '',
            path: '/authentication/sign-in/basic',
            component: <SignInBasic />,
          },
          {
            name: 'Cover',
            key: 'cover',
            layout: '',
            path: '/authentication/sign-in/cover',
            component: <SignInCover />,
          },
          {
            name: 'Illustration',
            key: 'illustration',
            layout: '',
            path: '/authentication/sign-in/illustration',
            component: <SignInIllustration />,
          },
        ],
      },
      {
        name: 'Sign Up',
        key: 'sign-up',
        collapse: [
          {
            name: 'Basic',
            key: 'basic',
            layout: '',
            path: '/authentication/sign-up/basic',
            component: <SignUpBasic />,
          },
          {
            name: 'Cover',
            key: 'cover',
            layout: '',
            path: '/authentication/sign-up/cover',
            component: <SignUpCover />,
          },
          {
            name: 'Illustration',
            key: 'illustration',
            layout: '',
            path: '/authentication/sign-up/illustration',
            component: <SignUpIllustration />,
          },
        ],
      },
    ],
  },
  // Simplified sign-in route at top level
  {
    type: 'auth',
    name: 'Sign In',
    key: 'sign-in-direct',
    layout: '',
    path: '/sign-in',
    component: <SignInBasic />,
  },
];

export default routes;
